import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { smsDonationIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';

interface SMSShareRoundProps {
  className?: string;
  onClick?: () => void;
}

export const SMSShareRound: React.FunctionComponent<SMSShareRoundProps> = ({
  className,
  onClick = () => {},
}) => {
  const { shareItems } = useShareContext();

  const { t } = useTranslation('common', { useSuspense: false });
  const linkItemClick = () => {
    onClick();
  };

  return (
    <IconButton className={`${styles.roundButton} ${className}`}>
      <a
        href={`sms://?&body=${encodeURIComponent(shareItems.sms.message)}`}
        onClick={linkItemClick}
      >
        <div className={classNames(styles.iconWrapper, styles.sms)}>
          <Svg markup={smsDonationIcon} className={styles.icon} />
        </div>
        {t('shareModal.sms')}
      </a>
    </IconButton>
  );
};
